import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { PageFeedbackModel } from '../models/page-feedback.model';

/** Page-level feedback (Unified Code criterion 40). */
@Injectable({ providedIn: 'root' })
export class PageFeedbackService {
  constructor(private apiClient: ApiClientService) {}

  /** Stores one feedback entry; the API answers with the new id. */
  submit(feedback: PageFeedbackModel): Observable<number> {
    return this.apiClient.create(ApplicationRoutes.PageFeedback.Controller, feedback);
  }
}
